import { CommonStatusTag } from 'components/CommonStatusTag';

import { DeliveryState } from 'data/__generated__';
import { DELIVERY_STATES_LABELS, getColorsFromState } from '../constants/states';

export const StatusTag = ({ state, showHeading }: { state: DeliveryState; showHeading?: boolean }) => {
    const { backgroundColor, labelColor } = getColorsFromState(state);
    return (
        <CommonStatusTag
            backgroundColor={backgroundColor}
            labelColor={labelColor}
            label={DELIVERY_STATES_LABELS[state]}
            showHeading={showHeading}
        />
    );
};
